import { render, staticRenderFns } from "./globalLoading.vue?vue&type=template&id=67ded17d&scoped=true&"
import script from "./globalLoading.vue?vue&type=script&lang=js&"
export * from "./globalLoading.vue?vue&type=script&lang=js&"
import style0 from "./globalLoading.vue?vue&type=style&index=0&id=67ded17d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ded17d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/globalLoading.vue
// module id = null
// module chunks = 